import React, { FC } from 'react'
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography'
import ErrorIcon from '@mui/icons-material/Error'

import {
  ColorName,
  ColorNameIcon,
  ColorNameTypography,
} from '../../../types/frontend/app'


const useStyles = makeStyles(theme => createStyles({
  root: {
    textAlign: 'center',
  },
}))

interface ErrorProps {
  color?: ColorName,
  message?: string,
}

const Error: FC<React.PropsWithChildren<ErrorProps>> = ({
  color = 'error',
  message = 'error',
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <ErrorIcon 
        color={ color as ColorNameIcon }
      />
      { 
        message && (
          <Typography
            variant='subtitle1'
            color={ color as ColorNameTypography }
          >
            { message }
          </Typography>
        )
      }
    </div>
  )
}

export default Error